import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
// H-F029: Llamada explícita en lugar de side effect al importar
import { initializeSubscriptions } from './lib/storeSubscriptions'
import './index.css'

initializeSubscriptions();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
